import React, { useEffect, useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { listarRango } from '../../services/turneroService';
import { Dialog, DialogContent, Button } from '@mui/material';
import VistaDetalladaAtencion from '../../pages/Recepcion/VistaDetalladaAtencion';

const CHECK_INTERVAL = 60000; // Revisar cada 1 minuto
const THRESHOLD_1_HOUR = 60 * 60 * 1000;
const THRESHOLD_30_MINS = 30 * 60 * 1000;

export default function AtencionTracker() {
    const { user } = useAuth();
    const [turnoActivo, setTurnoActivo] = useState(null);
    const [mostrarModalRecordatorio, setMostrarModalRecordatorio] = useState(false);
    const [mostrarModalFrame, setMostrarModalFrame] = useState(false);

    useEffect(() => {
        if (!user?.id) return;

        const chequearAtenciones = async () => {
            if (mostrarModalRecordatorio || mostrarModalFrame) return; // No chequear si ya estamos mostrando algo
            
            try {
                const hoy = new Date();
                const fechaHoy = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;
                // Obtener turnos de hoy para buscar si hay alguno EN_CURSO para este operador
                const turnosHoy = await listarRango(fechaHoy, fechaHoy);
                
                const enCurso = (turnosHoy || []).find((t) =>
                    String(t?.estado || '').trim().toUpperCase().replace(/\s+/g, '_') === 'EN_CURSO'
                    && Number(t?.idOperador) === Number(user.id)
                );

                if (enCurso && enCurso.inicioAtencion) {
                    const inicio = new Date(enCurso.inicioAtencion).getTime();
                    const ahora = new Date().getTime();
                    
                    const pospuestoKey = `atencion_pospuesta_${enCurso.idTurno}`;
                    const ultimoAviso = localStorage.getItem(pospuestoKey);
                    
                    if (ultimoAviso) {
                        const tiempoUltimoAviso = parseInt(ultimoAviso, 10);
                        if (ahora - tiempoUltimoAviso >= THRESHOLD_30_MINS) {
                            setTurnoActivo(enCurso);
                            setMostrarModalRecordatorio(true);
                        }
                    } else {
                        if (ahora - inicio >= THRESHOLD_1_HOUR) {
                            setTurnoActivo(enCurso);
                            setMostrarModalRecordatorio(true);
                        }
                    }
                } else if (!enCurso) {
                    // Si no hay ninguno en curso, limpiamos cualquier turno activo cacheados
                    setTurnoActivo(null);
                }
            } catch (error) {
                console.error("Error chequeando atenciones activas", error);
            }
        };

        chequearAtenciones();
        const interval = setInterval(chequearAtenciones, CHECK_INTERVAL);
        return () => clearInterval(interval);
    }, [user?.id, mostrarModalRecordatorio, mostrarModalFrame]);

    const handleContinuarAtendiendo = () => {
        if (turnoActivo) {
            const pospuestoKey = `atencion_pospuesta_${turnoActivo.idTurno}`;
            localStorage.setItem(pospuestoKey, new Date().getTime().toString());
        }
        setMostrarModalRecordatorio(false);
    };

    const handleCerrarAtencion = () => {
        setMostrarModalRecordatorio(false);
        setMostrarModalFrame(true);
    };

    return (
        <>
            {/* Modal de Recordatorio (Push In-App) */}
            <Dialog 
                open={mostrarModalRecordatorio} 
                onClose={() => {}} // Prevenir que se cierre tocando afuera
                PaperProps={{
                    style: {
                        padding: '1.5rem',
                        borderRadius: '12px',
                        textAlign: 'center',
                        maxWidth: '450px'
                    }
                }}
            >
                <DialogContent>
                    <div style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'center' }}>
                        <i className="bi bi-clock-history" style={{ fontSize: '3.5rem', color: '#0d6efd' }}></i>
                    </div>
                    
                    <h2 style={{ fontWeight: 'bold', fontSize: '1.5rem', marginBottom: '1rem', color: '#212529' }}>
                        ¿Finalizar atención al cliente?
                    </h2>
                    
                    <p style={{ fontSize: '1.05rem', color: '#6c757d', marginBottom: '0.5rem' }}>
                        Ha transcurrido bastante tiempo desde que inició la atención. El caso podría ya encontrarse resuelto.
                    </p>
                    <p style={{ fontSize: '1.05rem', color: '#6c757d', marginBottom: '1.5rem' }}>
                        ¿Deseas cerrar la atención del cliente?
                    </p>
                    
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <Button 
                            variant="contained" 
                            color="primary"
                            onClick={handleCerrarAtencion}
                            style={{ 
                                borderRadius: '8px',
                                padding: '0.8rem',
                                textTransform: 'none',
                                fontSize: '1.05rem',
                                fontWeight: 500
                            }}
                        >
                            Finalizar atención
                        </Button>
                        
                        <Button 
                            variant="outlined" 
                            onClick={handleContinuarAtendiendo}
                            style={{ 
                                borderRadius: '8px',
                                padding: '0.8rem',
                                textTransform: 'none',
                                fontSize: '1.05rem',
                                color: '#495057',
                                borderColor: '#ced4da'
                            }}
                        >
                            Continuar atendiendo
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>

            {/* Modal para cerrar la atención sin salir de la pestaña actual */}
            <Dialog
                open={mostrarModalFrame}
                onClose={() => setMostrarModalFrame(false)}
                maxWidth="xl"
                fullWidth
                PaperProps={{
                    style: {
                        height: '90vh',
                        backgroundColor: '#f8f9fa'
                    }
                }}
            >
                {mostrarModalFrame && turnoActivo && (
                    <div style={{ height: '100%', overflowY: 'auto' }}>
                        <VistaDetalladaAtencion 
                            idTurnoProp={turnoActivo.idTurno} 
                            enModal={true} 
                            onCerrarModal={() => setMostrarModalFrame(false)} 
                        />
                    </div>
                )}
            </Dialog>
        </>
    );
}
